import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const groupHospitals = (services) => {
  const groupedByHospital = services.reduce((acc, service) => {
    const {
      hospitalName,
      hospitalId,
      messageTypeName,
      hospitalTypeName,
      hospitalGroupId,
      hospitalGroupName,
      attachments,
    } = service;

    if (!acc[hospitalName]) {
      acc[hospitalName] = {
        hospitalName,
        hospitalId,
        hospitalTypeName,
        hospitalGroupId,
        hospitalGroupName,
        attachments,
        referralTypes: new Set([messageTypeName]),
      };
    } else {
      acc[hospitalName].referralTypes.add(messageTypeName);
    }

    return acc;
  }, {});

  const groupedHospitals = Object.values(groupedByHospital).map((hospital) => ({
    ...hospital,
    referralTypes: Array.from(hospital.referralTypes),
  }));

  const hospitalsWithGroup = groupedHospitals
    .filter((hospital) => Boolean(hospital.hospitalGroupName))
    .sort((a, b) => {
      const groupComparison = a.hospitalGroupName.localeCompare(
        b.hospitalGroupName,
        undefined,
        { sensitivity: "base" }
      );

      if (groupComparison !== 0) {
        return groupComparison;
      }

      return a.hospitalName.localeCompare(b.hospitalName, undefined, {
        sensitivity: "base",
      });
    });

  const hospitalsWithoutGroup = groupedHospitals
    .filter((hospital) => !hospital.hospitalGroupName)
    .sort((a, b) =>
      a.hospitalName.localeCompare(b.hospitalName, undefined, {
        sensitivity: "base",
      })
    );

  return [...hospitalsWithGroup, ...hospitalsWithoutGroup];
};

export const useHealthlinkAvailableServices = () => {
  const tenant = localStorage.getItem("kinesin-tenant");

  const fetchHealthlinkAvailableServices = async () => {
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.get(
      `${tenant}/healthlink/available-services`
    );

    return {
      hospitals: groupHospitals(response.data.facilities),
      facilities: response.data.facilities,
    };
  };

  return useQuery({
    queryKey: ["healthlinkAvailableServices", tenant],
    queryFn: fetchHealthlinkAvailableServices,
    enabled: !!tenant,
  });
};

export default useHealthlinkAvailableServices;
